// extracted by mini-css-extract-plugin
module.exports = {"root":"_0GSaqdR_","headingContainer":"_4HkvLyhI","heading":"_FsGlRUK","breadcrumbs":"glmi0dAq","content":"zOVdrOG9","contentList":"cu8f_kj7"};